module.exports = __webpack_public_path__ + "img/C03-1-Orquidea@2x.0f5569ba.png";